import axios from 'axios';
import { config } from '../config';
import { cognitoHelpers } from '../auth/cognito';

export const apiClient = axios.create({
  baseURL: config.apiUrl,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests
apiClient.interceptors.request.use(
  (config) => {
    const tokens = cognitoHelpers.getTokens();
    if (tokens?.idToken) {
      config.headers.Authorization = `Bearer ${tokens.idToken}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Handle 401 and 403 errors
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      cognitoHelpers.clearTokens();
      window.location.href = '/login';
    } else if (error.response?.status === 403) {
      const errBody = error.response?.data as { error?: string } | undefined;
      if (errBody?.error === 'terms_accepted_required') {
        window.location.href = '/terms';
      } else {
        // e.g. admin route without admin role
        window.location.href = '/';
      }
    }
    return Promise.reject(error);
  }
);
